import { render, staticRenderFns } from "./JLayoutClosableMenu.vue?vue&type=template&id=689a9f22&scoped=true&"
import script from "./JLayoutClosableMenu.vue?vue&type=script&lang=js&"
export * from "./JLayoutClosableMenu.vue?vue&type=script&lang=js&"
import style0 from "./JLayoutClosableMenu.vue?vue&type=style&index=0&id=689a9f22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689a9f22",
  null
  
)

export default component.exports